import { type HTMLMotionProps, motion } from 'motion/react';
import { useTranslation } from 'react-i18next';

const MoreButton: React.FC<HTMLMotionProps<'span'>> = props => {
  const { t } = useTranslation();

  return (
    <motion.span
      className="text-secondary-base cursor-pointer underline"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1, transition: { delay: 0.2 } }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.2 }}
      {...props}
    >
      {t('Button.more')}
      {' >'}
    </motion.span>
  );
};

export default MoreButton;
